import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const LoginPage = lazy(() => import('../pages/auth/LoginPage'));
const RegisterPage = lazy(() => import('../pages/auth/RegisterPage'));
const ResetPasswordPage = lazy(() => import('../pages/auth/ResetPasswordPage'));
const UpdatePasswordPage = lazy(() => import('../pages/auth/UpdatePasswordPage'));
const HomePage = lazy(() => import('../pages/home/page'));
const WalletsPage = lazy(() => import('../pages/wallets/page'));
const BudgetsPage = lazy(() => import('../pages/budgets/page'));
const TasksPage = lazy(() => import('../pages/tasks/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LoginPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/update-password',
    element: <UpdatePasswordPage />,
  },
  {
    path: '/home',
    element: <HomePage />,
  },
  {
    path: '/wallets',
    element: <WalletsPage />,
  },
  {
    path: '/budgets',
    element: <BudgetsPage />,
  },
  {
    path: '/tasks',
    element: <TasksPage />,
  },
  {
    path: '/settings',
    element: <SettingsPage />,
  },
  {
    path: '/setup',
    element: lazy(() => import('../pages/setup/page')),
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
